"use client";
import { useEffect, useState } from "react";
import { ArrowRightIcon, XMarkIcon } from "@heroicons/react/24/outline";
import SectionTitleComp from "./section-title.comp";
import { useRouter } from "next/navigation";
import { stripHTML } from "@/libs/formater";
import Image from "next/image";
import { motion } from "framer-motion";

export default function WorkPlanComp({
  category,
  categories,
}: {
  category: string;
  categories: any[];
}) {
  const router = useRouter();
  const [selectedCategory, setSelectedCategory] = useState<any | null>(
    categories[0]
  );
  const [selectedRenstra, setSelectedRenstra] = useState<any | null>(null);

  useEffect(() => {
    const filter = categories.filter((c) => c.id === category);
    if (filter.length > 0) {
      setSelectedCategory(filter[0]);
    }
  }, [category, categories]);

  return (
    <div className="">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <div>
          <SectionTitleComp title="Kategori" />
          <div className="grid grid-flow-row gap-4">
            {categories.map((c) => (
              <button
                key={c.id}
                className="w-full py-2 flex justify-between items-center ps-4 border-l-2 border-gray-400 disabled:border-green disabled:text-green"
                disabled={selectedCategory?.id === c.id}
                onClick={() => router.push(`/work-plan?category=${c.id}`)}
              >
                <span>{c.name} </span>
                <ArrowRightIcon className="size-4 hidden lg:block" />
              </button>
            ))}
          </div>
        </div>
        <div className="lg:col-span-3">
          <p className="mb-6 font-medium text-lg">{selectedCategory.name}</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-6">
            {selectedCategory &&
              selectedCategory.renstras.map((rs: any) => (
                <div
                  key={rs.id}
                  className="hover:opacity-75 cursor-pointer group"
                  onClick={() => setSelectedRenstra(rs)}
                >
                  <div className="rounded-xl bg-gray-500 mb-2">
                    <Image
                      src={rs.imageSrc}
                      alt={`${stripHTML(rs.title) || "kehutanan"} ${rs.id}`}
                      width={200}
                      height={200}
                      className="object-scale-down w-full h-36"
                    />
                  </div>
                  <p className="line-clamp-2 break-words group-hover:text-secondary group-hover:text-green">
                    {stripHTML(rs.title)}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </div>
      {selectedRenstra && (
        <div className="fixed inset-0 flex items-center justify-center bg-dark bg-opacity-80 p-4 z-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="relative max-w-3xl w-full bg-white p-4 rounded-xl lg:rounded-2xl"
          >
            <button
              className="absolute -top-3 -right-3 text-white bg-gray-800 p-2 rounded-full"
              onClick={() => setSelectedRenstra(null)}
            >
              <XMarkIcon className="size-6" />
            </button>
            <div className="mb-2">
              <p className="text-lg">{selectedRenstra.title}</p>
              <p className="text-gray-700">{selectedRenstra.description}</p>
            </div>
            {selectedRenstra.document && (
              <>
                <div className="relative mb-2">
                  <embed
                    src={selectedRenstra.document}
                    type="application/pdf"
                    className="w-full h-[500px]"
                  />
                </div>
                <div className="w-full text-right pt-2">
                  <a
                    href={selectedRenstra.document}
                    target="_blank"
                    className="bg-green px-6 py-2 rounded-lg text-center text-white hover:bg-green/80"
                  >
                    Unduh
                  </a>
                </div>
              </>
            )}
          </motion.div>
        </div>
      )}
    </div>
  );
}
